import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { action } from 'satcheljs/lib/legacy';
import { setPopoutData } from 'owa-popout-store';
export default action('prepareComposeViewStateForPopout')(function prepareComposeViewStateForPopout(viewState) {
    // Set viewstate popout information.
    viewState.docking.isPopout = true;
    viewState.isPopout = true;
    viewState.preferAsyncSend = false;
    // Don't show subject picker
    viewState.subjectPickerViewState.isPickerOpened = false;
    viewState.subjectPickerViewState.supportsSubjectPicker = false;
    // Store Compose ViewState in Local Storage
    setPopoutData("ComposePopoutViewState" /* ComposePopoutViewState */, viewState);
    // Store Attachment information in Local Storage
    if (viewState.attachmentWell) {
        var attachments_1 = [];
        viewState.attachmentWell.docViewAttachments.forEach(function (element) {
            attachments_1.push(getAttachment(element.attachmentId));
        });
        viewState.attachmentWell.imageViewAttachments.forEach(function (element) {
            attachments_1.push(getAttachment(element.attachmentId));
        });
        viewState.attachmentWell.inlineAttachments.forEach(function (element) {
            attachments_1.push(getAttachment(element.attachmentId));
        });
        setPopoutData("AttachmentPopoutViewState" /* AttachmentPopoutViewState */, attachments_1);
    }
});
//# sourceMappingURL=prepareComposeViewStateForPopout.js.map